export default __webpack_public_path__ + "static/media/vambraces_of_the_defiant.0df81628.jpg";